import React from 'react'

import SummaryImage from './Common/SummaryImage'
import AccommodationSummaryModalFooter from './Common/SummaryModalFooter/AccommodationSummaryModalFooter'
import ReadOnlyItemFooter from './Common/SummaryModalFooter/ReadOnlyItemFooter'
import RestoreCartModalFooter from '../Common/RestoreCartModalFooter'

import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import AccommodationItemSummaryContent from 'tripPlanner/components/TripModal/TripItems/Summary/AccommodationSummary/AccommodationItemSummaryContent'
import CustomItemSummaryContent from 'tripPlanner/components/TripModal/TripItems/Summary/AccommodationSummary/CustomItemSummaryContent'
import useCanEditTrip from 'tripPlanner/hooks/useCanEditTrip'
import useOffer from 'hooks/Offers/useOffer'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import type { AccommodationItem } from 'tripPlanner/types/tripItem'
import { isLeBookmark } from 'tripPlanner/utils'
import { isBookableItem } from 'tripPlanner/utils/bookmark/restoreCart'
import { isHotel } from 'lib/offer/offerTypes'

interface Props {
  item: AccommodationItem
}

function AccommodationItemSummary(props: Props) {
  const { item } = props

  const { closeModal, goBack } = useModalCallbacks()
  const [offer] = useOffer<App.Offer | App.BedbankOffer | App.VillaOffer>('code' in item ? item.code : undefined)
  const isLEAccommodation = isHotel(offer)

  const canEdit = useCanEditTrip()
  const isBookable = isLeBookmark(item) && isBookableItem(item)

  return (
    <>
      <ModalHeader
        title={item.place.name}
        subtitle={item.place.region}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <ModalBody>
        <SummaryImage
          place={item.place}
          tripId={item.tripId}
          tripItemId={item.id}
          offer={offer}
        />
        {isLEAccommodation && (
          <AccommodationItemSummaryContent item={item} offer={offer} />
        )}
        {!isLEAccommodation && <CustomItemSummaryContent item={item} />}
      </ModalBody>

      {canEdit && (
        <>
          {isBookable && <RestoreCartModalFooter item={item} />}
          {!isBookable && <AccommodationSummaryModalFooter item={item} />}
        </>
      )}
      {!canEdit && <ReadOnlyItemFooter item={item} />}
    </>
  )
}

export default AccommodationItemSummary
